import { render, staticRenderFns } from "./ChatContentDia.vue?vue&type=template&id=4b04ff6e&scoped=true&"
import script from "./ChatContentDia.vue?vue&type=script&lang=js&"
export * from "./ChatContentDia.vue?vue&type=script&lang=js&"
import style0 from "./ChatContentDia.vue?vue&type=style&index=0&id=4b04ff6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04ff6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b04ff6e')) {
      api.createRecord('4b04ff6e', component.options)
    } else {
      api.reload('4b04ff6e', component.options)
    }
    module.hot.accept("./ChatContentDia.vue?vue&type=template&id=4b04ff6e&scoped=true&", function () {
      api.rerender('4b04ff6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/newChat/ChatContentDia.vue"
export default component.exports